import React, { useEffect, useState } from 'react';
import { CloseIcon } from './icons/CloseIcon';

export const VideoPreviewModal = ({ videoUrl, onClose }) => {
    const [objectUrl, setObjectUrl] = useState(null);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onClose]);

    useEffect(() => {
        let isMounted = true;
        let tempUrl = null;

        if (videoUrl && videoUrl.startsWith('data:')) {
            fetch(videoUrl)
                .then(res => res.blob())
                .then(blob => {
                    if (isMounted) {
                        tempUrl = URL.createObjectURL(blob);
                        setObjectUrl(tempUrl);
                    }
                })
                .catch(error => {
                    console.error("Error converting data URL to blob URL:", error);
                    if (isMounted) {
                        setObjectUrl(videoUrl);
                    }
                });
        } else {
            setObjectUrl(videoUrl);
        }

        return () => {
            isMounted = false;
            if (tempUrl) {
                URL.revokeObjectURL(tempUrl);
            }
        };
    }, [videoUrl]);

    return (
        <div
            className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4"
            onClick={onClose}
            role="dialog"
            aria-modal="true"
        >
            <div
                className="bg-[#181820] border border-gray-700 rounded-2xl w-full max-w-4xl h-auto flex flex-col overflow-hidden relative"
                onClick={e => e.stopPropagation()}
            >
                <button 
                    onClick={onClose} 
                    className="absolute top-2 right-2 p-2 rounded-full bg-black/50 hover:bg-gray-700 z-10"
                    aria-label="Close video preview"
                >
                    <CloseIcon className="w-6 h-6 text-white" />
                </button>
                {objectUrl ? (
                    <video
                        src={objectUrl}
                        controls
                        autoPlay
                        loop
                        className="w-full max-h-[85vh] object-contain"
                    >
                        Your browser does not support the video tag.
                    </video>
                ) : (
                    <div className="w-full max-h-[85vh] aspect-video flex items-center justify-center">
                        <p className="text-gray-400">Loading video...</p>
                    </div>
                )}
            </div>
        </div>
    );
};
